/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react/require-default-props */
import React, { useState } from 'react';
import { Popover, TextField } from '@shopify/polaris';
import { ChromePicker } from 'react-color';
import rgbHex from 'rgb-hex';
import PropTypes from 'prop-types';
import './inputPicker.scss';

function InputPicker(props) {
  const [active, setActive] = useState(false);

  const openColorPicker = () => setActive(true);
  const closeColorPicker = () => setActive(false);

  const onColorChange = value => {
    props.applyColor(`#${rgbHex(value.rgb.r, value.rgb.g, value.rgb.b, value.rgb.a)}`);
  };
  return (
    <div className='InputPicker'>
      <TextField
        disabled
        value={props.value}
        label={<a title={props.label}>{props.label}</a>}
        connectedRight={
          <div onClick={openColorPicker} className='connect-right-item'>
            <Popover
              preferredPosition='below'
              active={active}
              activator={<div id='wrap-button-preview' style={{ backgroundColor: props.value }} />}
              onClose={closeColorPicker}
            >
              <ChromePicker color={props.value || '#e1e2e1'} onChange={onColorChange} />
            </Popover>
          </div>
        }
      >
        More actions
      </TextField>
    </div>
  );
}

InputPicker.propTypes = {
  label: PropTypes.string,
  value: PropTypes.string,
  applyColor: PropTypes.func.isRequired
};

export default InputPicker;
